export default "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADwAQCdASoQAAwAAsBMJaQAAq8jeiAx4QAA/oc2qR5VfAXyXSBiBKz9uvyl3t8gI15vf4tkGeqSp0QUVfUL+R6AAAA=";